export default {"src":"/_next/static/media/fille-arrow.f69a4cfc.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};